<template>
	<footer id="theme-footer">
		<CurvedLine top="#E5F2F4" bottom="#005782"/>
		<div class="container container--small">
			<PageLogo class="logo-row margin-top-sm" light />
			<SocialLinks class="margin-both-lg social-links-row"/>
			<div class="margin-both-lg  row-footer-text">
				<p class="text-footer" v-html="getOptions.footer_text"></p>
			</div>
			<div class="margin-both-lg footer-links-row">
				<ul class="footer-links" v-if="getOptions.footer_links && getOptions.footer_links.length">
					<li class="link" :key="k" v-for="(link, k) in getOptions.footer_links">
						<AcfLink class="slide-hover slide-hover--white" :data="link.link" />
					</li>
				</ul>
			</div>
		</div>
		
		<div class="container container--small cpr-footer padding-bottom-sm">
			<p style="margin-bottom: 5px;">© Opphavsrett {{currentYear}} {{blogName}} <span v-if="policyPage">• <WpLink class="slide-hover slide-hover--white slide-hover--tiny" :url="policyPage.slug" :title="policyPage.name">{{policyPage.name}}</WpLink></span></p>
			<p>Nettside levert av <a target="_blank" class="slide-hover slide-hover--white slide-hover--tiny" rel="noopener" href="//tankenbak.no">Tanken Bak</a></p>
		</div>

	</footer>
</template>


<script>
import WpLink from '@/components/elements/WpLink';
import CurvedLine from '@/components/elements/CurvedLine';
import PageLogo from '@/components/elements/PageLogo';
import SocialLinks from '@/components/elements/SocialLinks';
import AcfLink from '@/components/elements/AcfLink';

import { mapGetters } from 'vuex';

export default {
	name : 'theme-footer',
	components: {
		WpLink,
		SocialLinks,
		PageLogo,
		AcfLink,
		CurvedLine
    },
    data(){
        return{
			wpvue : window.WPVUE,
			blogName: window.WPVUE.blogname,
			currentYear: new Date().getFullYear()
        }
    },
    computed: {
        ...mapGetters([
            'getOptions'
		]),
		policyPage(){
			return this.wpvue.wp_page_for_privacy_policy_page || false
		}
	},
	methods:{
	}	
}
</script>


<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

#theme-footer{
	background-color: $darkLight;
	color: #fff;
	text-align: center;
	max-width: 100vw;
    overflow: hidden;
	.curved-block-line{
		width: 100%;
		margin-top: -1px;
	}
	.logo-row{
		a{
			display: block;
		}
		img{
			width: 96px;
			height: 100px;
			@include mquery($tablet){
				width: 67.2px;
				height: 70px;
			}
		}
	}
	.cpr-footer{
		p{
			margin: 0;
			@include fluid-type($smallResText, $wideResText, 10px, 12px);
		}
	}

	.text-footer{
		margin: 0;
		padding: 0;
		@include fluid-type($smallResText, $wideResText, 12px, 14px);
	}

	.footer-links{
		padding: 0;
		margin: 0;
		list-style: none;
		li{
			list-style: none;
		}
	}
	.social-links-block{
		
	}

	.footer-links{
		margin-left: -12.5px;
		margin-right: -12.5px;
		@include mquery($tablet){
			margin-left: -8px;
			margin-right: -8px;
		}
		.link{
			margin-left: 12.5px;
			margin-right: 12.5px;
			display: inline-block;
			@include mquery($tablet){
				margin-left: 8px;
				margin-right: 8px;
			}
		}
		a{
			text-decoration: none;
			font-weight: bold;
			@include fluid-type($smallResText, $wideResText, 14px, 20px);
		}
		@include mquery($tablet){

		}
	}
}

</style>